<template lang="pug">
  v-list
    v-list-tile(v-for="item, i in menu", :key="i", @click="goTo(item.ruta)", ripple)
      v-list-tile-avatar 
        v-icon(:class="item.iconClass") {{item.icon}}
      v-list-tile-content 
        v-list-tile-title {{item.texto}}

</template>

<script>
export default {
  props: ['menu'],
  methods: {
    goTo (ruta) {
      if (ruta === '/app/catalogo')
        this.$store.commit('cat/deVenta', false)
      if (this.$route.fullPath !== ruta)
        this.$router.push(ruta)
      this.$emit('clickMenu')
    }
  }
}
</script>

<style>

</style>